import { createSlice } from '@reduxjs/toolkit';
import type { SharedPathwayState } from './types';

const initialState: SharedPathwayState = {
  isLoading: false,
  error: false,
  hasMore: true,
  pathways: [],
  index: 0,
  step: 10
};

export const slice = createSlice({
  name: 'sharedPathways',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    noHasMore(state) {
      state.hasMore = false;
    },
    get(state, action) {
      state.isLoading = false;
      state.pathways = action.payload.items;
    },
    getMorePosts(state) {
      const setIndex = state.index + 1;
      state.index = setIndex;
    }
  }
});

// Reducer
export default slice.reducer;

export const { getMorePosts } = slice.actions;
